if (!customElements.get('product-form')) {
	console.log('fefewfewfe')
	customElements.define('product-form', class ProductForm extends HTMLElement {
		constructor() {
			super();

			this.form = this.querySelector('form');
			this.form.querySelector('[name=id]').disabled = false;
			this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
			this.minicart = document.querySelector('mini-cart');
			this.eventContext = this.form.dataset.eventContext;
			this.hideErrors = this.dataset.hideErrors === 'true';

			this.form.addEventListener('change', (event) => {
				if (event.target.matches('[name=id]')) {
					this.onVariantChange(event);
				}
			});
		}

		onVariantChange(event) {
			this.selectedVariant = event.target.value;
			const selectedOption = event.target.selectedOptions[0];

			if (selectedOption) {
				const price = selectedOption.dataset.price;
				const compareAtPrice = selectedOption.dataset.compareAtPrice;

				this.updatePriceDisplay(price, compareAtPrice);
			}

			const variantEvent = new CustomEvent('product-form:variant-change', {
				detail: {
					selectedVariant: this.selectedVariant,
					context: this.eventContext
				}
			});
			document.dispatchEvent(variantEvent);
		}

		updatePriceText(element, newPrice) {
			if (!element) return;
			// Loop over all child nodes
			element.childNodes.forEach((node) => {
				// Only update text nodes that contain a number
				if (node.nodeType === Node.TEXT_NODE && /\d/.test(node.textContent)) {
					node.textContent = ` ${window.formatMoney(newPrice)} `;
				}
			});
		}

		updatePriceDisplay(price, compareAtPrice) {
			const priceContainer = this.closest('product-card')?.querySelector('.price-container');
			if (!priceContainer) return;

			// Current sale price
			const currentPrice = priceContainer.querySelector('.price-item-sale .price--current');
			this.updatePriceText(currentPrice, price);

			// Regular price (can appear alone or with sale)
			const regularPrice = priceContainer.querySelector('.price-item-regular');
			if (regularPrice) {
				// If there's a compare-at price and it's higher than sale, update that
				if (compareAtPrice && parseInt(compareAtPrice) > parseInt(price)) {
					this.updatePriceText(regularPrice, compareAtPrice);
				} else {
					// Otherwise, treat it as the main price
					this.updatePriceText(regularPrice, price);
				}
			}
		}
		

		onSubmitHandler(event) {
			event.preventDefault();
			const submitButton = this.querySelector('[type="submit"]');
			if (submitButton.classList.contains('loading')) {
				return;
			}

			this.handleErrorMessage();

			submitButton.setAttribute('aria-disabled', true);
			submitButton.classList.add('loading');
			this.querySelector('.button-overlay-spinner').classList.remove('hidden');

			const config = fetchConfig('javascript');
			config.headers['X-Requested-With'] = 'XMLHttpRequest';
			delete config.headers['Content-Type'];

			const formData = new FormData(this.form);
			formData.append('sections', this.minicart.getSectionsToRender().map((section) => section.id));
			formData.append('sections_url', window.location.pathname);
			config.body = formData;

			fetch(`${routes.cart_add_url}`, config)
				.then((response) => response.json())
				.then((response) => {
					if (response.status) {
						publish(PUB_SUB_EVENTS.cartError, {
							source: 'product-form',
							productVariantId: formData.get('id'),
							errors: response.errors || response.description,
							message: response.message,
						});

						this.handleErrorMessage(response.description);
						return;
					}

					this.minicart.renderContents(response);
                    //commented out and rewritten below to get the smart cart working. 
                    // if (window.themeSettings.redirectToCart) {
					// 	location.href = '/cart';
					// } else {
					// 	this.minicart.open(submitButton);
					// }

                    if (window.Rebuy && window.Rebuy.SmartCart && window.Rebuy.SmartCart.status === 'ready') {
					Rebuy.SmartCart.show()
					} else if (window.themeSettings.redirectToCart) {
						location.href = '/cart';
					} else {
						this.minicart.open(submitButton);
					}
					const event = new CustomEvent('cart:item-add', {
						detail: {
							items: [response],
							context: this.eventContext,
						},
					});
					document.dispatchEvent(event);

					publish(PUB_SUB_EVENTS.cartItemAdd, {
						source: this.eventContext,
						items: [response],
					});
				})
				.catch((e) => {
					console.error(e);
				})
				.finally(() => {
					submitButton.classList.remove('loading');
					submitButton.removeAttribute('aria-disabled');
					this.querySelector('.button-overlay-spinner').classList.add('hidden');
				});
		}

		handleErrorMessage(errorMessage = false) {
			if (this.hideErrors) {
				return;
			}

			this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form-error-message-wrapper');
			this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form-error-message');

			this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

			if (errorMessage) {
				this.errorMessage.textContent = errorMessage;
			}
		}
	});
}
